import { render, staticRenderFns } from "./DataTableActionIcons.vue?vue&type=template&id=7e1e3ebb&"
import script from "./DataTableActionIcons.vue?vue&type=script&lang=ts&"
export * from "./DataTableActionIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
